/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungDto } from '../../models/buchung-dto';
import { UpdateBuchungDto } from '../../models/update-buchung-dto';

export interface UpdateOneBuchung$Json$Params {

/**
 * ID der Buchung die aktualisiert werden soll
 */
  buchungsId: string;
  
    /**
     * Aktualisierte Daten für die Buchung
     */
    body?: UpdateBuchungDto
}

export function updateOneBuchung$Json(http: HttpClient, rootUrl: string, params: UpdateOneBuchung$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<BuchungDto>> {
  const rb = new RequestBuilder(rootUrl, updateOneBuchung$Json.PATH, 'put');
  if (params) {
    rb.path('buchungsId', params.buchungsId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BuchungDto>;
    })
  );
}

updateOneBuchung$Json.PATH = '/v1/buchungen/{buchungsId}';
